export class FilterModel {
    id: number;
    departamentItemCode: string;
    entityCode: number;
    group: string;
    year: number;
    version: number;
    type_id: number;
    employee_code: number;
    itemCode: string;
  }
  